import React from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  Button,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LanguageIcon from "@mui/icons-material/Language";
import DescriptionIcon from "@mui/icons-material/Description";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DownloadIcon from "@mui/icons-material/Download";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { RootState, useAppDispatch } from "../../../store";
import { setContractDashboardFilters } from "../../../store/filtersSlice";
import {
  CONTRACT_TYPE_OPTIONS,
  GROUP_COMPANY_OPTIONS,
} from "../../../utils/constants";
import styles from "./dashboardFilters.module.scss";

interface DashboardFiltersProps {
  title: string;
  subtitle: string;
}

const DashboardFilters: React.FC<DashboardFiltersProps> = ({
  title,
  subtitle,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { contractDashboardFilters } = useSelector(
    (state: RootState) => state.filters,
  );

  const handleGroupCompanyChange = (value: string) => {
    dispatch(setContractDashboardFilters({ groupCompany: value }));
  };

  const handleContractTypeChange = (value: string) => {
    dispatch(setContractDashboardFilters({ contractType: value }));
  };

  const handleDateRangeChange = (value: string) => {
    dispatch(setContractDashboardFilters({ dateRange: value }));
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.headerContent}>
        <Box className={styles.titleSection}>
          <Typography variant="h4" className={styles.title}>
            {title}
          </Typography>
          <Typography variant="body2" className={styles.subtitle}>
            {subtitle}
          </Typography>
        </Box>
        <Box className={styles.controlsSection}>
          <FormControl className={styles.dropdown}>
            <Box className={styles.dropdownWrapper}>
              <LanguageIcon className={styles.dropdownIcon} />
              <Select
                value={contractDashboardFilters.groupCompany}
                onChange={(e) => handleGroupCompanyChange(e.target.value)}
                displayEmpty
                IconComponent={KeyboardArrowDownIcon}
                className={styles.select}
              >
                <MenuItem value="" disabled>
                  Accellor Group Companies
                </MenuItem>
                {GROUP_COMPANY_OPTIONS.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </FormControl>

          <FormControl className={styles.dropdown}>
            <Box className={styles.dropdownWrapper}>
              <DescriptionIcon className={styles.dropdownIcon} />
              <Select
                value={contractDashboardFilters.contractType}
                onChange={(e) => handleContractTypeChange(e.target.value)}
                displayEmpty
                IconComponent={KeyboardArrowDownIcon}
                className={styles.select}
              >
                <MenuItem value="" disabled>
                  Contract Type
                </MenuItem>
                {CONTRACT_TYPE_OPTIONS.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </FormControl>

          {/* Temporarily hidden - Date duration selector */}
          {/* <FormControl className={styles.dropdown}>
            <Box className={styles.dropdownWrapper}>
              <CalendarTodayIcon className={styles.dropdownIcon} />
              <Select
                value={contractDashboardFilters.dateRange}
                onChange={(e) => handleDateRangeChange(e.target.value)}
                displayEmpty
                IconComponent={KeyboardArrowDownIcon}
                className={styles.select}
              >
                <MenuItem value="Oct 2024 - Dec 2024">
                  Oct 2024 - Dec 2024
                </MenuItem>
              </Select>
            </Box>
          </FormControl> */}

          {/* Temporarily hidden - Export Data button */}
          {/* <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            className={styles.exportButton}
          >
            Export Data
          </Button> */}
          <Button
            variant="contained"
            startIcon={<ChatBubbleOutlineIcon />}
            className={styles.talkButton}
            onClick={() => navigate("/chat/procurement-insights")}
          >
            Talk with Data
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardFilters;
